// ============================================================================
// KOREAN TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// 말씀에서 추출된 영적 보물

export const bibleTreasuresKo = [
  {
    type: "perle_sagesse",
    content: "거룩한 지혜는 추상적 이론이 아니라 우리의 일상적 선택 속에 나타나는 구체적인 삶입니다",
    reference: "잠언 3:13-18",
    category: "지혜",
    strongNumbers: {
      "지혜": "H2451", // חָכְמָה (chokmah) = 실천적 지혜
      "명철": "H8394" // תְּבוּנָה (tebunah) = 분별력
    },
    reflection: "오늘 어떤 결정에서 하나님의 지혜를 적용할 수 있을까요?"
  },
  {
    type: "tresor_divine",
    content: "하나님의 사랑은 우리의 공로에 좌우되지 않고 하나님 자신의 본질에서 흘러나오는 영원한 선물입니다",
    reference: "로마서 8:38-39",
    category: "사랑",
    strongNumbers: {
      "사랑": "G26", // ἀγάπη (agape) = 무조건적 사랑
      "끊을": "G5563" // χωρίζω (chorizo) = 분리하다
    },
    reflection: "그리스도 안에 나타난 하나님의 사랑에서 우리를 끊을 수 있는 것은 아무것도 없습니다"
  },
  {
    type: "lumiere_vie",
    content: "예수님은 우리의 길일 뿐만 아니라 우리의 내면을 비추는 빛이십니다",
    reference: "요한복음 8:12",
    category: "정체성",
    strongNumbers: {
      "빛": "G5457", // φῶς (phos) = 빛
      "생명": "G2222" // ζωή (zoe) = 풍성한 생명
    },
    reflection: "그리스도의 빛이 나의 어두운 영역을 비추도록 하려면?"
  },
  {
    type: "force_divine",
    content: "우리의 힘은 우리 자신에게서 나오는 것이 아니라 우리 안에 거하시는 분에게서 나옵니다",
    reference: "에베소서 3:16-17",
    category: "힘",
    strongNumbers: {
      "능하게 하시고": "G2901", // κραταιόω (krataioo) = 강하게 하다
      "능력": "G1411" // δύναμις (dynamis) = 신적인 능력
    },
    reflection: "약한 순간에 하나님의 능력을 신뢰하고 있나요?"
  },
  {
    type: "paix_profonde",
    content: "하나님의 평강은 외적 상황이 아니라 우리 마음속에 계신 하나님의 지속적인 임재에 달려 있습니다",
    reference: "빌립보서 4:6-7",
    category: "고요함",
    strongNumbers: {
      "평강": "G1515", // εἰρήνη (eirene) = 완전한 평화
      "지키시리라": "G5432" // φρουρέω (phroureo) = 요새처럼 지키다
    },
    reflection: "모든 이해를 초월하는 하나님의 평강을 어떻게 기를 수 있을까요?"
  },
  {
    type: "esperance_vivante",
    content: "우리의 소망은 불확실한 소원이 아니라 하나님의 신실한 약속에 기초한 견고한 닻입니다",
    reference: "히브리서 6:19",
    category: "소망",
    strongNumbers: {
      "소망": "G1680", // ἐλπίς (elpis) = 확신에 찬 소망
      "닻": "G45" // ἄγκυρα (ankyra) = 영혼의 닻
    },
    reflection: "오늘 어떤 하나님의 약속에 소망의 닻을 내릴까요?"
  },
  {
    type: "transformation",
    content: "영적 변화는 지속적인 과정이며, 우리는 날마다 그리스도의 형상을 더욱 닮아갑니다",
    reference: "고린도후서 3:18",
    category: "성장",
    strongNumbers: {
      "변화하여": "G3339", // μεταμορφόω (metamorphoo) = 완전히 변화시키다
      "영광": "G1391" // δόξα (doxa) = 신적인 영광
    },
    reflection: "오늘 내 삶의 어떤 영역이 변화가 필요할까요?"
  }
];

export default bibleTreasuresKo;
